import { CloudSun, GraduationCap, MapPinned } from "lucide-react";

import type { ServiceType } from "../data/types";

export const servicePresentation = {
  balloon: { label: "Vuelo", icon: CloudSun },
  tour: { label: "Tour", icon: MapPinned },
  school: { label: "Grupo escolar", icon: GraduationCap },
} satisfies Record<ServiceType, { label: string; icon: typeof CloudSun }>;

export function ServiceBadge({ service, tentative = false }: { service: ServiceType; tentative?: boolean }) {
  const presentation = servicePresentation[service];
  const Icon = presentation.icon;
  return (
    <span className={`service-badge service-badge--${service}${tentative ? " service-badge--tentative" : ""}`}>
      <Icon aria-hidden="true" />
      <span>{presentation.label}</span>
    </span>
  );
}
